import { render, staticRenderFns } from "./LocalOcorrencia.vue?vue&type=template&id=6a52b286&scoped=true&"
import script from "./LocalOcorrencia.vue?vue&type=script&lang=js&"
export * from "./LocalOcorrencia.vue?vue&type=script&lang=js&"
import style0 from "./LocalOcorrencia.vue?vue&type=style&index=0&id=6a52b286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a52b286",
  null
  
)

export default component.exports